define.alias("shared/components/shared/ui/switcher/item", "settings/components/shared/ui/switcher/item");